import { store } from '../../store/store'
import { Theme } from '../models/funnelOrder/theme'
import { SiteCountry } from '../models/locale'
import { commonEntries } from './commonEntries'
import { driveEntries } from './driveEntries'
import { flyEntries } from './flyEntries'
import { Entry, EntryKey, EntryPage, EntryType } from './types'

export const entries: Entry[] = flyEntries
  .concat(driveEntries)
  .concat(commonEntries)

export function getEntries(
  theme: Theme,
  country: SiteCountry,
  amount?: number,
  types?: EntryType[],
) {
  const themeEntries = entries.filter(
    x =>
      // In theme
      (x.theme === undefined || x.theme === theme) &&
      // Is active
      isEntryActive(x) &&
      // Isn't hidden
      x.hide !== true &&
      // Is in types
      (types === undefined || types.includes(x.type)) &&
      // Hasn't expired
      (x.expiry ? new Date() <= new Date(x.expiry) : true) &&
      // Started already
      (x.startFrom ? new Date() >= new Date(x.startFrom) : true),
  )

  return themeEntries
    .sort((x, y) => (x.order?.[country] || 99) - (y.order?.[country] || 99))
    .slice(0, amount ? amount : 10)
}

export function isEntryActive(entry: Entry): boolean {
  const state = store.getState()
  let wrongCountry = false
  let expired = false
  if (entry.page) {
    wrongCountry = !entry.page.url.hasOwnProperty(state.locale.country)
  }
  if (entry.expiry) {
    expired = new Date() > new Date(entry.expiry)
  }
  return entry.active && !wrongCountry && !expired
}

export function getEntry(entry: EntryKey): Entry | undefined {
  const filteredEntries = entries.filter(x => x.key === entry)
  return filteredEntries[0]
}

export function getEntryUrl(
  page: EntryPage,
  forceCountry?: SiteCountry,
): string {
  const state = store.getState()
  if (page.url.hasOwnProperty(state.locale.country)) {
    const country = forceCountry || state.locale.country.toLowerCase()
    return page.url[country]
  }
  return ''
}

export function getEntryFromUrl(url: string): Entry | null {
  return (
    entries.find(x =>
      x.page ? Object.values(x.page.url).includes(url) : false,
    ) || null
  )
}
